<template>
  <div></div>
</template>

<script>
  export default {
    name: "file_out_empty_page"
  }
</script>

<style scoped>
  .test-clear {
    clear: both;
  }
</style>
